import Vue from "vue";
import Vuex from "vuex";
import materials from "./materials";
import courses from "./courses";
//import exams from "./exams";
import user from "./user";
import admin from "./admin";
import exams from "./exams";
import leodata from "./leodata";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: user,
    materials: materials,
    courses: courses,
    //exams: exams,
    admin: admin,
    exams: exams,
    leodata: leodata,
  },
});
